/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvitationContextResponseEnterpriseCompanyMostActiveMembersMember2
 */
export interface InvitationContextResponseEnterpriseCompanyMostActiveMembersMember2 {
    /**
     * The first name of the member 1
     * @type {string}
     * @memberof InvitationContextResponseEnterpriseCompanyMostActiveMembersMember2
     */
    firstName?: string;
}

/**
 * Check if a given object implements the InvitationContextResponseEnterpriseCompanyMostActiveMembersMember2 interface.
 */
export function instanceOfInvitationContextResponseEnterpriseCompanyMostActiveMembersMember2(value: object): value is InvitationContextResponseEnterpriseCompanyMostActiveMembersMember2 {
    return true;
}

export function InvitationContextResponseEnterpriseCompanyMostActiveMembersMember2FromJSON(json: any): InvitationContextResponseEnterpriseCompanyMostActiveMembersMember2 {
    return InvitationContextResponseEnterpriseCompanyMostActiveMembersMember2FromJSONTyped(json, false);
}

export function InvitationContextResponseEnterpriseCompanyMostActiveMembersMember2FromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitationContextResponseEnterpriseCompanyMostActiveMembersMember2 {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
    };
}

export function InvitationContextResponseEnterpriseCompanyMostActiveMembersMember2ToJSON(value?: InvitationContextResponseEnterpriseCompanyMostActiveMembersMember2 | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstName': value['firstName'],
    };
}

